export const setDataBackupList = (state, payload) => {
    state.list = payload.response    
}


// WEBPACK FOOTER //
// ./src/store/modules/dataBackup/mutations.js